import { render, staticRenderFns } from "./nonbindSVip.vue?vue&type=template&id=7da8ec99&scoped=true"
import script from "./nonbindSVip.vue?vue&type=script&lang=js"
export * from "./nonbindSVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da8ec99",
  null
  
)

export default component.exports